/**
 * Which RTO City/Location options a user may pick from in the Online Policy form.
 *
 *  - a CLIENT (master admin)                    -> the whole master
 *  - a user with NO RTO assigned (User.rtocityids empty) -> the whole master
 *  - a user with one or more assigned           -> only those
 *  - assignments not loaded yet (`assignedIds` is null) -> nothing, so the full
 *    master is never flashed and then narrowed
 *
 * The saved RTO of an edited policy stays selectable even when it is no longer
 * assigned (or no longer in the list), otherwise editing would clear the field.
 *
 * @param {Object}   o
 * @param {Object[]} o.all           every RTO option: { _id, value, label, ... }
 * @param {Set<string>|null} o.assignedIds  the user's assigned RTO ids, null until loaded
 * @param {boolean}  o.isMasterAdmin
 * @param {Object|null} [o.saved]   the option the policy already holds
 */
export function visibleRtoOptions({ all, assignedIds, isMasterAdmin, saved = null }) {
  const list = Array.isArray(all) ? all : [];
  if (isMasterAdmin) return list;
  if (!assignedIds) return [];

  const allowed =
    assignedIds.size === 0
      ? list
      : list.filter((rto) => assignedIds.has(String(rto._id)));

  if (saved && !allowed.some((rto) => rto.value === saved.value)) {
    return [saved, ...allowed];
  }
  return allowed;
}
